<ul *ngFor="let version of versions">
  <li><a class="scroll-link" (click)="scrollToVersion('version-' + version.number)">Version {{ version.number }}</a></li>
  <yo-numberVersion *ngIf="version.subVersions.length > 0" [versions]="version.subVersions"></yo-numberVersion>
</ul>
